import { inject } from '@angular/core';
import { ENVIRONMENT } from '@interacta-shared/data-access-configuration';
import {
    bindNotificationComponent,
    NotificationConfig,
} from '@interacta-shared/data-access-notification';
import { ActivityCreatedOrAssignedNotificationComponent } from '../components/activity-created-or-assigned-notification/activity-created-or-assigned-notification.component';
import { ActivityEditNotificationComponent } from '../components/activity-edit-notification/activity-edit-notification.component';
import { ChangeStatusNotificationComponent } from '../components/change-status-notification/change-status-notification.component';
import { EditPostAttachmentsNotificationComponent } from '../components/edit-post-attachments-notification/edit-post-attachments-notification.component';
import { FeedbackTaskChangeStatusNotificationComponent } from '../components/feedback-task-change-status-notification/feedback-task-change-status-notification.component';
import { TaskNotificationComponent } from '../components/task-notification/task-notification.component';
import { UserNotificationComponent } from '../components/user-notification/user-notification.component';
import { toUserNotificationEventDelta } from '../models/user-notification.deserialize';
import { UserNotificationEventType } from '../models/user-notification.model';
import { taskUserNotificationEventTypes } from './user-notification.util';

export const notificationConfigFactory = (): NotificationConfig => {
    const notificationsBaseUrl = `${inject(ENVIRONMENT).apiBasePath.common}/internal/notifications`;
    return {
        endpoints: {
            userChannel: `${notificationsBaseUrl}/channels/users`,
            stream: `${notificationsBaseUrl}/stream`,
            unreadCount: `${notificationsBaseUrl}/unread`,
            markAsRead: `${notificationsBaseUrl}/read`,
            markAllAsRead: `${notificationsBaseUrl}/read/all`,
        },

        deserializeFn: toUserNotificationEventDelta,
        components: {
            ...bindNotificationComponent(
                TaskNotificationComponent,
                ...taskUserNotificationEventTypes,
            ),
            [UserNotificationEventType.CHANGE_STATUS]:
                ChangeStatusNotificationComponent,
            [UserNotificationEventType.FEEDBACK_TASK_CHANGE_STATUS]:
                FeedbackTaskChangeStatusNotificationComponent,
            [UserNotificationEventType.EDITED_POST_ATTACHMENTS]:
                EditPostAttachmentsNotificationComponent,
            [UserNotificationEventType.ACTIVITY_EDIT]:
                ActivityEditNotificationComponent,
            ...bindNotificationComponent(
                ActivityCreatedOrAssignedNotificationComponent,
                UserNotificationEventType.CREATION, // same notification type user for other post types. Bounded component must handle it properly
                UserNotificationEventType.ACTIVITY_ASSIGNED,
            ),
            default: UserNotificationComponent,
        },
        htmlNotificationIcon: 'assets/images-2.0/main-logo_72x72.png',
        provider: 'sql-tree',
    };
};
